/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";

import type { ThemeType } from "../../../../global/emotion";
import type { HallowElementProps } from "../../../types/hallowElementProps.types";

const blockquoteStyle: Interpolation<ThemeType> = (theme) => ({
  borderBottom: theme.stroke.none,
  borderLeftColor: theme.semanticColors.primary,
  borderLeftStyle: "solid",
  borderLeftWidth: theme.stroke.heavy,
  borderRight: theme.stroke.none,
  borderTop: theme.stroke.none,
  color: theme.semanticColors.neutralsMedium,
  marginBlock: theme.spacing.s,
  marginInline: theme.spacing.none,
  paddingBlock: theme.spacing.none,
  paddingInline: theme.spacing.s,
});

export const Blockquote = ({
  children,
  ...props
}: HallowElementProps<"blockquote">) => {
  return (
    <blockquote css={blockquoteStyle} {...props}>
      {children}
    </blockquote>
  );
};
